
class LocalStorage {
  constructor(storeType) {
    this.subscribers = [];
    this.intervalHandler = null;
    try {
      this.store = window[storeType];
      this.checkAccessThrowable(this.store);
    } catch (e) {
      this.store = undefined;
    }
  }

  checkAccessThrowable(store) {
    const prefix = 'integration_jira_';
    const testVal = `${Math.random()}`;
    store.setItem(`${prefix}test`, testVal);
    if (store.getItem(`${prefix}test`) !== testVal) {
      throw new Error('store.getItem() did not return expected value');
    }
  }

  isAccessible() {
    return Boolean(this.store);
  }

  getItem(key) {
    try {
      return JSON.parse(this.store.getItem(key));
    } catch (e) {
      return undefined;
    }
  }

  setItem(key, val) {
    if (val === undefined) {
      this.store.removeItem(key);
    } else {
      this.store.setItem(key, JSON.stringify(val));
    }

    this._handleChange();
  }

  onChange(key, cb) {
    const o = {
      cb,
      key,
      old: JSON.stringify(this.getItem(key))
    };

    this.subscribers.push(o);

    if (!this.intervalHandler) {
      this.intervalHandler = setInterval(() => this._handleChange(), 2000);
    }

    return () => {
      this.subscribers = this.subscribers.filter(s => s !== o);
      if (!this.subscribers.length) {
        clearInterval(this.intervalHandler);
        this.intervalHandler = null;
      }
    };
  }

  _handleChange() {
    this.subscribers.forEach(s => {
      const { old, cb } = s;
      const val = JSON.stringify(this.getItem(s.key));
      if (val !== old) {
        setTimeout(() => cb(val ? JSON.parse(val) : undefined, old ? JSON.parse(old) : undefined), 0);
        s.old = val;
      }
    });
  }
}

const localStorage = new LocalStorage('localStorage');
const sessionStorage = new LocalStorage('sessionStorage');

export { localStorage, sessionStorage };
